import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { isBefore } from "date-fns";

export const appl170ValidationSchema = () => {
  const { t } = useTranslation();
  const comparisonDate = new Date(1900, 0, 1); // Month is 0-based (0 = January)
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    mergePlanDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .test(
        "is-after-1900",
        t(
          "Ελέγξτε την ημερομηνία των πρακτικών του ΔΣ για την έναρξη των εργασιών. Η ημερομηνία θα πρέπει να έχει τη μορφή ΗΗ/ΜΜ/ΥΥΥΥ (π.χ. 30/03/2022)."
        ),
        function (value) {
          return value && !isBefore(value, comparisonDate);
        }
      ),
    fudocMergePlan: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocDS: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    dsDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .test(
        "is-after-1900",
        t(
          "Ελέγξτε την ημερομηνία των πρακτικών του ΔΣ για την έναρξη των εργασιών. Η ημερομηνία θα πρέπει να έχει τη μορφή ΗΗ/ΜΜ/ΥΥΥΥ (π.χ. 30/03/2022)."
        ),
        function (value) {
          return value && !isBefore(value, comparisonDate);
        }
      ),
    fudocDSMergePlan: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    dsMergePlanDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .test(
        "is-after-1900",
        t(
          "Ελέγξτε την ημερομηνία των πρακτικών του ΔΣ για την έναρξη των εργασιών. Η ημερομηνία θα πρέπει να έχει τη μορφή ΗΗ/ΜΜ/ΥΥΥΥ (π.χ. 30/03/2022)."
        ),
        function (value) {
          return value && !isBefore(value, comparisonDate);
        }
      ),
    acquiredGemi: yup
      .array()
      .min(
        1,
        t("Προσοχή! Πρέπει η επιχείρησή σας να μετέχει στο σχέδιο σύμβασης.")
      ),
    acquiringGemi: yup
      .string()
      .required(t("Πρέπει να εισαγάγετε ακριβώς μία Απορροφώσα εταιρεία.")),
  });
};
